import React, { Component } from "react";
import { Link } from "react-router-dom";
import NavItem from "./NavItem";
import PropTypes from "prop-types";

class PageNav extends Component {
	constructor(props) {
		super(props);
		this.state = { show: false };
	}

	componentDidMount() {
		//this.props.loadExperiences(appKey);
		setTimeout(() => {
			this.setState({ show: true });
		}, 300);
	}
	renderExperience = page => {
		let { appKey, expId } = this.props.match.params;
		console.log(this.props);
		return (
			<NavItem key={page.id} linkTo={`/apps/${appKey}/experiences/${expId}/pages/${page.key}`} text={page.name} />
		);
	};

	render() {
		let { appKey, expId } = this.props.match.params;
		//const {experiences} = this.props.experiences; TODO Get pages
		return (
			<div className={`animate animate-show${this.state.show ? " animated" : ""}`}>
				<Link to={`/apps/${appKey}/experiences/${expId}`} className="sidebar-back">
					<i className="fal fa-chevron-left"></i> <span>My Experience</span>
				</Link>
			</div>
		);
	}
}
PageNav.propTypes = {
	auth: PropTypes.object,
	actions: PropTypes.object,
	location: PropTypes.object,
	apps: PropTypes.object,
	match: PropTypes.object,
	loadExperiences: PropTypes.func,
	experiences: PropTypes.object,
};
export default PageNav;
